// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ChainedFunction<T extends any[]> = ((...args: T) => void) | undefined | null;

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
export function createChainedFunction<A extends unknown[]>(
  ...fns: ChainedFunction<A>[]
): (...args: A) => void {
  return function mergedFn(...args: A) {
    fns.forEach((fn) => {
      fn?.(...args);
    });
  };
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = (): void => {};
